import { render, staticRenderFns } from "./HomeAnnouncementsComponent.vue?vue&type=template&id=58891849"
import script from "./HomeAnnouncementsComponent.vue?vue&type=script&lang=js"
export * from "./HomeAnnouncementsComponent.vue?vue&type=script&lang=js"
import style0 from "./HomeAnnouncementsComponent.vue?vue&type=style&index=0&id=58891849&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports